import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Form } from '@unform/web';
import { uuid } from 'uuidv4';
import { FormHandles } from '@unform/core';
import { FiCamera } from 'react-icons/fi';
import { RiCloseLine } from 'react-icons/ri';
import { FaRegTrashAlt } from 'react-icons/fa';
import {
  createStyles,
  Grid,
  makeStyles,
  Modal,
  Theme,
  Backdrop,
  Fade,
} from '@material-ui/core';

import InputLogged from '../../../../../../../../components/InputLogged';
import Select from '../../../../../../../../components/Select';

import {
  useProdutoPizza,
  ItemComplemento,
} from '../../../../../../../../hooks/produtoPizza';
import { useToast } from '../../../../../../../../hooks/toast';
import { useAuth } from '../../../../../../../../hooks/auth';

import tipos from '../../../../../../utils/tiposGrupo';

import api from '../../../../../../../../services/api';

import no_image from '../../../../../../../../assets/no_image.png';

import {
  ButtonAction,
  LabelWrapper,
  NewImg,
  QtdItemContainer,
  TabWrapper,
} from '../../../../drawer_styles';
import {
  AddButton,
  TrashBtnWrapper,
} from '../../../../../../../Configuracoes/TabBar/tabs/styles';
import material_styles from '../../../../drawer_styles/material_styles';
import {
  SubmitButtonWrapper,
  ModalWrapper,
  StatusSaleButton,
} from '../../../../../styles';

interface OptionType {
  id: string;
  value: string;
  label: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: '70%',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #757575',
      borderRadius: '6px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 0, 3),
    },
  }),
);

const Complementos: React.FC = () => {
  const classes = material_styles();
  const modalClasses = useStyles();

  const { addToast } = useToast();
  const { user } = useAuth();
  const {
    produtoId,
    cloning,
    produtoPizzaData,
    selectedComplementoIndex,
    changeProdutoPizzaData,
    resetComplementosTab,
  } = useProdutoPizza();

  const formRef = useRef<FormHandles>(null);

  const [materiasPrimas, setMateriasPrimas] = useState<OptionType[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmacaoModal, setConfirmacaoModal] = useState(false);
  const [itens, setItens] = useState<ItemComplemento[]>([]);

  useEffect(() => {
    const complementoIsStored =
      typeof produtoPizzaData.complementos.find(
        (complemento) => complemento.index === selectedComplementoIndex,
      )?.id === 'number';

    if (complementoIsStored) {
      setItens(
        produtoPizzaData.itens_complemento.filter(
          (item) => item.index_complemento === selectedComplementoIndex,
        ),
      );
    } else {
      setItens([
        {
          id: uuid(),
          qtd_min: 0,
          qtd_max: 1,
          descricao: '',
          preco: 0,
          index_complemento: selectedComplementoIndex,
          tipo: Number(tipos.PIZZA),
          empresa_id: user.empresa_id,
          isNew: true,
          ordem: 0,
        },
      ]);
    }
  }, [user, produtoPizzaData, selectedComplementoIndex]);

  const handleImage = useCallback((productImg: any) => {
    if (productImg) {
      if (typeof productImg === 'string') {
        return `http://localhost:3333/files/${productImg}`;
      }

      return URL.createObjectURL(productImg);
    }

    return no_image;
  }, []);

  const handleToggleModal = useCallback((value: boolean) => {
    setModalOpen(value);
  }, []);

  const handleActiveChange = useCallback(
    (value: boolean, id: number | string) => {
      setItens((oldState) =>
        oldState.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              pausar_venda: !value,
            };
          }

          return item;
        }),
      );
    },
    [],
  );

  const handleAddComplemento = useCallback(() => {
    setItens((oldState) => [
      ...oldState,
      {
        id: uuid(),
        qtd_min: 0,
        qtd_max: 1,
        descricao: '',
        preco: 0,
        index_complemento: selectedComplementoIndex,
        tipo: Number(tipos.PIZZA),
        pausar_venda: false,
        empresa_id: user.empresa_id,
        isNew: true,
        ordem: oldState.length,
      },
    ]);
  }, [user, selectedComplementoIndex]);

  const handleCancel = useCallback(() => {
    changeProdutoPizzaData({
      complementos: produtoPizzaData.complementos.filter((complemento) => {
        if (complemento.index === selectedComplementoIndex) {
          if (!complemento.id) {
            return false;
          }
        }

        return true;
      }),
    });

    resetComplementosTab();
  }, [
    produtoPizzaData,
    selectedComplementoIndex,
    resetComplementosTab,
    changeProdutoPizzaData,
  ]);

  useEffect(() => {
    async function loadMateriasPrimas(): Promise<void> {
      const response = await api.get(`/produto/tipo/${2}`);

      const optionItems: OptionType[] = [];

      response.data.map((item: any) => {
        const option = {
          id: item.id,
          value: item.id,
          label: item.descricao,
        };

        optionItems.push(option);
      });

      setMateriasPrimas(optionItems);
    }

    loadMateriasPrimas();
  }, []);

  const handleSubmit = useCallback(
    async (data: any) => {
      if (itens.length === 0) {
        addToast({
          type: 'error',
          title: 'Você precisa adicionar pelo menos um item.',
        });

        return;
      }

      const currentComplemento = produtoPizzaData.complementos.find(
        (complemento) => complemento.index === selectedComplementoIndex,
      );

      if (itens.length < (currentComplemento?.qtd_min || 0)) {
        addToast({
          type: 'error',
          title: 'Você precisa adicionar mais itens.',
          description: `O complemento ${currentComplemento?.descricao} precisa ter pelo menos ${currentComplemento?.qtd_min} item(ns).`,
        });

        return;
      }

      const hasDescription = itens.every((item) => item.descricao);

      if (!hasDescription) {
        addToast({
          type: 'error',
          title: 'Não é possível cadastrar itens sem nome.',
        });

        return;
      }

      const hasMateriaPrima = itens.every((item) => item.produto_id);

      if (!hasMateriaPrima && !confirmacaoModal) {
        setModalOpen(true);

        return;
      }

      const itensComplementoIsValid = itens.every((item) => {
        if (item.qtd_min > item.qtd_max) {
          addToast({
            type: 'error',
            title: 'Quantidade inválida.',
            description: `A quantidade mínima do item ${item.descricao} deve ser maior que a quantidade máxima.`,
          });

          return false;
        }

        return true;
      });

      if (itensComplementoIsValid) {
        changeProdutoPizzaData({
          itens_complemento: [
            ...produtoPizzaData.itens_complemento.filter(
              (item) => item.index_complemento !== selectedComplementoIndex,
            ),
            ...itens,
          ],
        });

        resetComplementosTab();
      }
    },
    [
      itens,
      produtoPizzaData,
      confirmacaoModal,
      selectedComplementoIndex,
      addToast,
      changeProdutoPizzaData,
      resetComplementosTab,
    ],
  );

  const handleChangeMateriaPrima = useCallback(
    (id: number | string, materiaPrima: any) => {
      setItens((oldState) =>
        oldState.map((item) => {
          if (String(item.id) === String(id)) {
            return {
              ...item,
              produto_id: materiaPrima.value,
              isNew: true,
            };
          }

          return item;
        }),
      );
    },
    [],
  );

  const handleSetComplementoValue = useCallback(
    (id: number | string, field: string, value: any) => {
      const updatedItems = itens.map((item_complemento) => {
        if (String(item_complemento.id) === String(id)) {
          return {
            ...item_complemento,
            [field]: value,
            isNew: true,
          };
        }

        return item_complemento;
      });

      setItens(updatedItems);
    },
    [itens],
  );

  const handleDeleteComplemento = useCallback(
    async (id: number | string) => {
      changeProdutoPizzaData({
        itens_complemento: produtoPizzaData.itens_complemento.filter(
          (item_complemento) => String(item_complemento.id) !== String(id),
        ),
      });

      if (typeof id === 'number') {
        await api.delete(`/complemento/item/${id}`);
      }
    },
    [produtoPizzaData, changeProdutoPizzaData],
  );

  return (
    <TabWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.noPaddingBot}>
          <AddButton type="button" onClick={handleAddComplemento}>
            + Adicionar Complemento
          </AddButton>
        </Grid>

        <Grid item xs={12}>
          <Form ref={formRef} onSubmit={handleSubmit}>
            {itens.map((item, index) => (
              <div className="form_item" key={String(index)}>
                <Grid container spacing={3}>
                  <Grid item xs={3}>
                    <NewImg>
                      <img
                        src={handleImage(item.imagem)}
                        alt="Item Complemento"
                      />

                      <label htmlFor={`complemento_img${item.id}`}>
                        <FiCamera size={20} />
                        <input
                          type="file"
                          id={`complemento_img${item.id}`}
                          onChange={(event: ChangeEvent<HTMLInputElement>) => {
                            if (event.target.files) {
                              handleSetComplementoValue(
                                item.id,
                                'imagem',
                                event.target.files[0],
                              );
                            }
                          }}
                        />
                      </label>
                    </NewImg>
                  </Grid>

                  <Grid item xs={9}>
                    <Grid container spacing={1}>
                      <Grid
                        item
                        xs={produtoId && !cloning ? 4 : 6}
                        className={classes.noPaddingTop}
                      >
                        <LabelWrapper>
                          <span>Nome do complemento</span>
                        </LabelWrapper>
                        <InputLogged
                          name={`descricao${item.id}`}
                          placeholder="Digite o nome"
                          defaultValue={item.descricao}
                          onChange={(event) =>
                            handleSetComplementoValue(
                              item.id,
                              'descricao',
                              event.target.value,
                            )
                          }
                        />
                      </Grid>

                      <Grid
                        item
                        xs={produtoId && !cloning ? 4 : 5}
                        className={classes.noPaddingTop}
                      >
                        <LabelWrapper>
                          <span>Matéria Prima</span>
                        </LabelWrapper>
                        <Select
                          name={`produto_id${item.id}`}
                          placeholder="Matéria prima"
                          options={materiasPrimas}
                          value={materiasPrimas.find(
                            (materia) =>
                              String(materia.value) === String(item.produto_id),
                          )}
                          onChange={(value) =>
                            handleChangeMateriaPrima(item.id, value)
                          }
                        />
                      </Grid>

                      {produtoId && !cloning ? (
                        <Grid
                          item
                          xs={3}
                          className={classes.noPaddingTop}
                          style={{ textAlign: 'center' }}
                        >
                          <LabelWrapper style={{ marginBottom: 5 }}>
                            <span>Ativo</span>
                          </LabelWrapper>
                          <StatusSaleButton
                            type="button"
                            isPaused={!item.pausar_venda}
                            className="paused"
                            onClick={() =>
                              handleSetComplementoValue(
                                item.id,
                                'pausar_venda',
                                true,
                              )
                            }
                          >
                            Não
                          </StatusSaleButton>

                          <StatusSaleButton
                            type="button"
                            isPaused={!!item.pausar_venda}
                            className="activated"
                            onClick={() =>
                              handleSetComplementoValue(
                                item.id,
                                'pausar_venda',
                                false,
                              )
                            }
                          >
                            Sim
                          </StatusSaleButton>
                        </Grid>
                      ) : null}

                      <Grid item xs={1} className={classes.noPaddingTop}>
                        <TrashBtnWrapper>
                          <button
                            type="button"
                            onClick={() => handleDeleteComplemento(item.id)}
                          >
                            <FaRegTrashAlt size={20} />
                          </button>
                        </TrashBtnWrapper>
                      </Grid>

                      <Grid item xs={3} className={classes.noPaddingTop}>
                        <LabelWrapper>
                          <span>Preço</span>
                        </LabelWrapper>
                        <InputLogged
                          name={`preco${item.id}`}
                          type="number"
                          placeholder="Preco"
                          step=".001"
                          defaultValue={item.preco}
                          onChange={(event) =>
                            handleSetComplementoValue(
                              item.id,
                              'preco',
                              event.target.value,
                            )
                          }
                        />
                      </Grid>

                      <Grid item xs={3} className={classes.noPaddingTop}>
                        <LabelWrapper>
                          <span>Código PDV</span>
                        </LabelWrapper>
                        <InputLogged
                          name={`codigo_complemento${item.id}`}
                          placeholder="Código"
                          defaultValue={item.codigo_complemento}
                          onChange={(event) =>
                            handleSetComplementoValue(
                              item.id,
                              'codigo_complemento',
                              event.target.value,
                            )
                          }
                        />
                      </Grid>

                      <Grid item xs={3} className={classes.qtdWrapperStyle}>
                        <QtdItemContainer>
                          <div className="control-wrapper">
                            <span>Mínimo</span>

                            <div>
                              <button
                                type="button"
                                className="decrement"
                                onClick={() => {
                                  if (item.qtd_min - 1 >= 0) {
                                    handleSetComplementoValue(
                                      item.id,
                                      'qtd_min',
                                      item.qtd_min - 1,
                                    );
                                  }
                                }}
                              >
                                -
                              </button>

                              <input
                                type="number"
                                min="0"
                                readOnly
                                value={item.qtd_min}
                              />

                              <button
                                type="button"
                                className="increment"
                                onClick={() =>
                                  handleSetComplementoValue(
                                    item.id,
                                    'qtd_min',
                                    item.qtd_min + 1,
                                  )
                                }
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </QtdItemContainer>
                      </Grid>

                      <Grid item xs={3} className={classes.qtdWrapperStyle}>
                        <QtdItemContainer>
                          <div className="control-wrapper">
                            <span>Máximo</span>

                            <div>
                              <button
                                type="button"
                                className="decrement"
                                onClick={() => {
                                  if (item.qtd_max - 1 >= 1) {
                                    handleSetComplementoValue(
                                      item.id,
                                      'qtd_max',
                                      item.qtd_max - 1,
                                    );
                                  }
                                }}
                              >
                                -
                              </button>

                              <input
                                type="number"
                                min={1}
                                readOnly
                                value={item.qtd_max}
                              />

                              <button
                                type="button"
                                className="increment"
                                onClick={() =>
                                  handleSetComplementoValue(
                                    item.id,
                                    'qtd_max',
                                    item.qtd_max + 1,
                                  )
                                }
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </QtdItemContainer>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            ))}

            <Grid item xs={12} className={classes.noPaddingBot}>
              <SubmitButtonWrapper>
                <ButtonAction
                  type="button"
                  className="cancel"
                  onClick={handleCancel}
                >
                  Cancelar
                </ButtonAction>

                <ButtonAction type="submit" className="submit">
                  Continuar
                </ButtonAction>
              </SubmitButtonWrapper>
            </Grid>
          </Form>
        </Grid>
      </Grid>
      <Modal
        className={modalClasses.modal}
        open={modalOpen}
        onClose={() => handleToggleModal(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalOpen}>
          <ModalWrapper>
            <div className="header">
              <h1>Confirmação</h1>

              <button type="button" onClick={() => handleToggleModal(false)}>
                <RiCloseLine size={30} />
              </button>
            </div>

            <div className="description">
              <span>
                Complementos sem matéria prima não terão seu estoque controlado.
                Deseja continuar?
              </span>
            </div>

            <div className="btnActions">
              <button
                type="button"
                className="confirm"
                onClick={() => {
                  setConfirmacaoModal(true);
                  handleToggleModal(false);
                  setTimeout(() => formRef.current?.submitForm(), 0);
                }}
              >
                Confirmar
              </button>

              <button
                type="button"
                className="cancel"
                onClick={() => handleToggleModal(false)}
              >
                Cancelar
              </button>
            </div>
          </ModalWrapper>
        </Fade>
      </Modal>
    </TabWrapper>
  );
};

export default Complementos;
